export const TEXTS = {
  MODAL_UPDATED_TITLE: 'Выберите тип устройства',
  MODAL_WARNING_TITLE: 'Волна уже запущена',

  MODAL_ADDRESS_TITLE: (address: string) => `На адресе: ${address}`,

  SUCCESS_BUTTON: 'Выбрать',
  SUCCESS_CHANGE_BUTTON: 'Изменить устройство',
  CANCEL_BUTTON: 'Назад',

  WEBPLAYER_TITLE: 'Веб-плеер',
  WEBPLAYER_DESCRIPTION: 'Просто запустите плеер в браузере',

  DESKTOP_TITLE: 'Приложение для ПК',
  DESKTOP_DESCRIPTION: 'Подходит для Windows, может работать без интернета',

  MOBILE_TITLE: 'Мобильное приложение',
  MOBILE_AUDIO_DESCRIPTION: 'Подходит для iOS, Android и Эвотора',
  MOBILE_VIDEO_DESCRIPTION: 'Для Android',

  ANDROID_TITLE: 'Android-приложение',

  BOOM_SPEAKER_TITLE: 'Умная колонка SberBoom',
  BOOM_SPEAKER_DESCRIPTION: 'Для музыки нужна только колонка и интернет',

  SBER_BUSINESS_PLAYER_TITLE: 'Плеер Звук Бизнес',
  SBER_BUSINESS_PLAYER_DESCRIPTION: 'Работает без интернета и дополнительных устройств',

  CHANGE_DEVICE_TYPE_WARNING: 'При изменении типа устройства вещание на текущем устройстве будет прервано',

  ALICE_TITLE: 'Алиса',
  RPI_TITLE: 'RPI',
  MUSICBOX_TITLE: 'Musicbox',
  NETCORE_TITLE: 'Netcore',
  PAVO_TITLE: 'Pavo',

  VIDEO_PLAYER_TITLE: 'Телевизор',
  VIDEO_PLAYER_DESCRIPTION: 'Можно подключить любой телевизор с Android TV',

  TAB_AUDIO_TITLE: 'Для аудиоволн',
  TAB_VIDEO_TITLE: 'Для видеоволн',
};
